import type { Archive } from "../../domain/types";
export function prepareTurn(archive: Archive, input: string) {
  if (!input.trim()) throw new Error("请输入行动或对话");
  const frozen = structuredClone(archive);
  return {
    frozen,
    input: input.trim(),
    turnId: `turn_${Date.now()}`,
    consumedContexts: {
      crafting: Boolean(archive.pendingCraftingContext),
      hunt: Boolean(archive.pendingHuntContext),
    },
  };
}
